import { Controller } from '@hotwired/stimulus'
import { t } from '@lingui/core/macro'
import { csrfHeader } from '~/utils/csrf'

export default class extends Controller {
  static targets = ['input', 'result', 'error', 'form']
  static values = { url: String }

  connect() {
    this.debounceTimer = null
    this.abortController = null
  }

  handleInput(event) {
    const value = event.target.value

    // Sincroniza com o hidden field do formulário
    const hiddenInput = document.getElementById('change-scheduler-cron')
    if (hiddenInput) {
      hiddenInput.value = value
    }

    // Clear previous timer
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }

    // Clear previous request
    if (this.abortController) {
      this.abortController.abort()
    }

    // Debounce: wait 750ms before making request
    this.debounceTimer = setTimeout(() => {
      this.validateCron(value)
    }, 750)
  }

  async validateCron(cron) {
    if (!cron.trim()) {
      this.clearResult()
      return
    }

    this.abortController = new AbortController()

    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          ...csrfHeader(),
        },
        body: JSON.stringify({ cron }),
        signal: this.abortController.signal,
      })

      if (!response.ok) {
        const data = await response.json()
        this.showError(data.error || t`Invalid CRON expression`)
        return
      }

      const data = await response.json()
      this.showResult(data)
    } catch (error) {
      if (error.name !== 'AbortError') {
        this.showError(t`Error validating CRON expression`)
      }
    }
  }

  showResult(data) {
    const resultEl = this.resultTarget
    if (!resultEl) return

    resultEl.innerHTML = `
      <div class="alert alert-info alert-sm mt-2 d-flex flex-column" role="alert">
        <strong class="text-info">${data.description || ''}</strong> 
      </div>
    `

    this.clearError()
  }

  showError(message) {
    const errorEl = this.errorTarget
    if (!errorEl) return

    errorEl.innerHTML = `
      <div class="alert alert-danger alert-sm mt-2 text-danger" role="alert">
        ${message}
      </div>
    `

    const resultEl = this.resultTarget
    if (resultEl) {
      resultEl.innerHTML = ''
    }
  }

  clearResult() {
    const resultEl = this.resultTarget
    if (resultEl) {
      resultEl.innerHTML = ''
    }
    this.clearError()
  }

  clearError() {
    const errorEl = this.errorTarget
    if (errorEl) {
      errorEl.innerHTML = ''
    }
  }

  disconnect() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
    if (this.abortController) {
      this.abortController.abort()
    }
  }
}
